// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import FileTextOutlinedSvg from "@ant-design/icons-svg/lib/asn/FileTextOutlined";
import AntdIcon from "../components/AntdIcon";
const FileTextOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: FileTextOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    FileTextOutlined.displayName = "FileTextOutlined";
}
export default /*#__PURE__*/ React.forwardRef(FileTextOutlined);
